"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.isArray=void 0,exports.isArray=Array.isArray;